import { render, staticRenderFns } from "./AttoreFilter.vue?vue&type=template&id=0a458808&"
import script from "./AttoreFilter.vue?vue&type=script&lang=ts&"
export * from "./AttoreFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports